<ng-container *transloco="let t">
    <div
        #reference
        class="tms-map-button-solo"
    >
        <bazis-button fill="clear">
            <bazis-icon
                slot="icon-only"
                [name]="isColllapse ? 'chevron-left': 'chevron-right'"
            ></bazis-icon>
        </bazis-button>
        <!-- <bazis-tooltip
            [reference]="reference"
            placement="left"
            class="bh-popper-z-index"
            [isStatic]="true"
            [offset]="[-12, 0]"
            [arrow]="false"
            >{{ t('map.tooltip.lasso') }}</bazis-tooltip
        > -->
    </div>
</ng-container>
